var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.element_loading),expression:"element_loading"}],attrs:{"element-loading-text":"拼命加载中......","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_vm._v("\n  我是趋势图\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }